import {fetchListings} from '../../actions/listings';
import {HIDE_GOOGLE_MAP} from '../../actions/action-types';

// Actions
export function onFetchListingsRetry(dispatch, segmentKey) {
    return () => {
        dispatch(fetchListings({segmentKey}));
    };
}

export function hideGoogleMap() {
    return {
        type: HIDE_GOOGLE_MAP,
    };
}

// Reducer
export default function reduceGreatPlaces(state = {}, action) {
    switch (action.type) {
        case HIDE_GOOGLE_MAP:
            return {
                ...state,
                hideGoogleMap: true,
            };

        default:
            return state;
    }
}
